angular.module('wbControllers').controller('HomeBuyingController',

  ['$scope', 'tax', 'geo', 'finance', 'homeBuyingPlan',
    ($scope, tax, geo, finance, homeBuyingPlan) => {
      $scope.errorTooManyYears = false;
      $scope.$watch('options',
        (options) => {
          geo.getProvince((result) => {
            if (result.province != null ? result.province.length : undefined) {
              options.province = result.province;
              return options.province;
            }
          });
          if ($scope.homeBuying.$valid) {
            $scope.data = homeBuyingPlan.calculatePlanData(options);
            return $scope.data;
          }
        },
        true);

      $scope.monthlyCostOfHousing = () => $scope.mortgagePayment() + (($scope.options.percentYearlyUpkeep * $scope.options.desiredHousePrice) / 12);

      $scope.mortgagePayment = () => finance.annuityPaymentFromPresentValue($scope.options.desiredHousePrice * (1 - $scope.options.percentDownPayment), $scope.options.projectedMortgageRate / 12, $scope.options.mortgagePeriod * 12);

      $scope.housingCostPercentOfIncome = () => $scope.monthlyCostOfHousing() / ($scope.options.grossIncome / 12);

      $scope.options = {
        grossIncome: 100000,
        monthlySavings: 2000,
        existingSavings: 0,
        existingRRSPSavings: 0,
        existingTFSASavings: 0,
        desiredHousePrice: 550000,
        projectedMortgageRate: 0.035,
        mortgagePeriod: 25, // number of years to pay off mortgage
        percentDownPayment: 0.20,
        percentClosingCosts: 0.03,
        percentYearlyUpkeep: 0.02,
        province: 'BC',
        interestRate: 0.04,
        inflationRate: 0.02,
      };
      return $scope.options;
    },
  ]);
